import React, { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { Typography, ButtonBase, IconButton  } from "@mui/material";
import styles from "./Style.module.css";
import Constants from "../../../config/constants";
import useQuizListHook from "./QuizListHook";
import SidePanelComponent from "../../../components/SidePanel/SidePanel.component";
import ShadowBox from "../../../components/ShadowBox/ShadowBox";
import FilterComponent from "../../../components/Filter/Filter.component";
import DataTables from "../../../Datatables/Datatable.table";
import { ArrowPrimaryButton } from "../../../components/Buttons/PrimaryButton";
import { Add } from "@mui/icons-material";
import StatusPill from "../../../components/Status/StatusPill.component";
import { ListActionComponent } from "../../../components/CustomListHeader/CustomListHeader";
import copy from "../../../assets/CRMAssets/ic_duplicate_grey@2x.png";
import useRoles from "../../../hooks/RoleHook";

const QuizList = (props) => {
  const {
    handleSortOrderChange,
    handleRowSize,
    isSidePanel,
    handleSideToggle,
    handlePageChange,
    handleEdit,
    handleEditSidePannel,
    handleFilterDataChange,
    handleSearchValueChange,
    configFilter,
    handleCreate,
    editData,
    handleDetail,
    handleDrag,
    handleCopy
  } = useQuizListHook({});
  const {canDelete, canRead, canCreate, canUpdate} = useRoles(Constants.MODULES.QUIZES_MODULE);

  const {
    present,
    all: allData,
    currentPage,
    is_fetching: isFetching,
  } = useSelector((state) => state.quiz);

  const renderStatus = useCallback((status) => {
    if (status === "ACTIVE") {
      return <StatusPill status={"ACTIVE"} color={"active"} />;
    } else {
      return <StatusPill status={status} color={status} />;
    }
  }, []);

  const tableStructure = useMemo(
    () => [
      {
        key: "full_contact",
        label: "Quiz Topic",
        sortable: false,
        render: (temp, all) => (
          <div className={styles.titleCont}>{all?.title}</div>
        ),
      },

      {
        key: "question",
        label: "Questions",
        sortable: false,
        render: (temp, all) => <div>{all?.total_questions}</div>,
      },
      {
        key: "reward",
        label: "Reward Points",
        sortable: false,
        render: (temp, all) => <div>{all?.total_reward_points}</div>,
      },
      {
        key: "time",
        label: "Timestamp of pushing on app",
        sortable: false,
        render: (temp, all) => <div>{all?.startDateText}</div>,
      },
      {
        key: "status",
        label: "Status",
        sortable: false,
        render: (temp, all) => <div>{renderStatus(all?.status)}</div>,
      },
      {
        key: "user_id",
        label: "Action",
        render: (temp, all) => (
          <div className={styles.listActionContainer}>
            <ListActionComponent
              allData={all}
              handleEdit={canUpdate ? handleEdit : null}
              handleDetail={canRead ? handleDetail : null}
              key={all?.id}
            />
            {/* <IconButton
              
              onClick={() => handleCopy(all)}
            >
             <img src={copy} alt="copy" className={styles.copy}/>
            </IconButton> */}
          </div>
        ),
      },
    ],
    [handleEdit, handleEditSidePannel, renderStatus]
  );
  const tableData = useMemo(() => {
    const datatableFunctions = {
      onSortOrderChange: handleSortOrderChange,
      onPageChange: handlePageChange,
      onRowSizeChange: handleRowSize,
      handleDrag: handleDrag,
    };
    const datatable = {
      ...Constants.DATATABLE_PROPERTIES,
      columns: tableStructure,
      data: present,
      count: allData.length,
      page: currentPage,
      draggable: true,
    };

    return { datatableFunctions, datatable };
  }, [
    allData,
    tableStructure,
    handleSortOrderChange,
    handlePageChange,
    handleDrag,
    handleRowSize,
    present,
    currentPage,
  ]);
  const panelTitle = editData
    ? "Edit City Information"
    : "Add City Information";
  return (
    <div>
      <ShadowBox className={styles.unit}>
        <div className={styles.headerContainer}>
          <div className={styles.actionButton}>
            <Typography
              variant={"title"}
              color={"text.primary"}
              className={styles.title}
            >
              Quiz List
            </Typography>
          </div>
          {canCreate &&<ArrowPrimaryButton
            onClick={handleCreate}
            icon={<Add fontSize="normal" />}
          >
            ADD QUIZ
          </ArrowPrimaryButton>}
        </div>
        <div>
          <FilterComponent
            is_progress={isFetching}
            filters={configFilter}
            handleSearchValueChange={handleSearchValueChange}
            handleFilterDataChange={handleFilterDataChange}
            placeholder="Search by quiz topic"
          />
          <div>
            <br />
            <div style={{ width: "100%" }}>
              <DataTables
                {...tableData.datatable}
                {...tableData.datatableFunctions}
              />
            </div>
          </div>
        </div>
      </ShadowBox>
    </div>
  );
};

export default QuizList;
